module.exports = __webpack_public_path__ + "img/back_neck_depth.303db5fe.png";